<template>
  <div class="echart04">
    <div ref="echart04" style="width:100%; height:200px;"></div>
  </div>
</template>

<script>
export default {
  props:{
    data04:{type: Object}
  },
  mounted() {
    let chart04 = this.$echarts.init(this.$refs.echart04)

    // let xAxisData = ['2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015','2014','2013']
    let xAxisData = this.data04.years;
    let tempSumList = this.data04.sumList[0];
    this.data04.sumList =[];
    this.data04.sumList.push(tempSumList.COUNT0);
    this.data04.sumList.push(tempSumList.COUNT1);
    this.data04.sumList.push(tempSumList.COUNT2);
    this.data04.sumList.push(tempSumList.COUNT3);
    this.data04.sumList.push(tempSumList.COUNT4);
    this.data04.sumList.push(tempSumList.COUNT5);
    this.data04.sumList.push(tempSumList.COUNT6);
    this.data04.sumList.push(tempSumList.COUNT7);
    this.data04.sumList.push(tempSumList.COUNT8);
    this.data04.sumList.push(tempSumList.COUNT9);


    let tempManList = this.data04.manList[0];
    this.data04.manList =[];
    this.data04.manList.push(tempManList.COUNT0);
    this.data04.manList.push(tempManList.COUNT1);
    this.data04.manList.push(tempManList.COUNT2);
    this.data04.manList.push(tempManList.COUNT3);
    this.data04.manList.push(tempManList.COUNT4);
    this.data04.manList.push(tempManList.COUNT5);
    this.data04.manList.push(tempManList.COUNT6);
    this.data04.manList.push(tempManList.COUNT7);
    this.data04.manList.push(tempManList.COUNT8);
    this.data04.manList.push(tempManList.COUNT9);

    let tempWoManList = this.data04.woManList[0];
    this.data04.woManList =[];
    this.data04.woManList.push(tempWoManList.COUNT0);
    this.data04.woManList.push(tempWoManList.COUNT1);
    this.data04.woManList.push(tempWoManList.COUNT2);
    this.data04.woManList.push(tempWoManList.COUNT3);
    this.data04.woManList.push(tempWoManList.COUNT4);
    this.data04.woManList.push(tempWoManList.COUNT5);
    this.data04.woManList.push(tempWoManList.COUNT6);
    this.data04.woManList.push(tempWoManList.COUNT7);
    this.data04.woManList.push(tempWoManList.COUNT8);
    this.data04.woManList.push(tempWoManList.COUNT9);

    let yAxisData1 = this.data04.sumList;
    // let yAxisData1 = [100, 38, 50, 73, 80, 50, 80, 30,30,30]
    let yAxisData2=this.data04.manList
    let yAxisData3=this.data04.woManList
    // let yAxisData2 = [70, 20, 24, 50, 40, 45, 70, 18,30,30]
    // let yAxisData3 = [30, 18, 26, 13, 40, 5, 10, 12,30,30]

    let option = {
      backgroundColor: '',
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          lineStyle: {
            color: 'rgb(126,199,255)',
          },
        },
      },
      color: ["#3087fe", "#05fef5", "#f64d6b"],
      grid: {
        top: '20%',
        left: '2%',
        right: '5%',
        bottom: '20%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          axisLine: {
            //坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: '#327490',
            },
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置
            formatter: function (value) {
              var str = "";
              var num = 4; //每行显示字数
              var valLength = value.length; //该项x轴字数
              var rowNum = Math.ceil(valLength / num); // 行数

              if (rowNum > 1) {
                for (var i = 0; i < rowNum; i++) {
                  var temp = "";
                  var start = i * num;
                  var end = start + num;

                  temp = value.substring(start, end) + "\n";
                  str += temp;
                }
                return str;
              } else {
                return value;
              }
            },
            textStyle: {
              color: '#FFFFFF',
              // fontSize: 22,
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#233653',
            },
          },
          axisTick: {
            show: false,
          },
          data: xAxisData,
        },
      ],
      yAxis: [
        {
          name: "",
          position: 'left',
          nameTextStyle: {
            color: "#fff",
            // fontSize: 24,
            padding: [0, 0, 0, 0]
          },
          // minInterval: 1,
          type: 'value',
          splitLine: {
            show: false,
            lineStyle: {
              color: '#1160a0',
              type: 'dashed'
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#008de7',
            },
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: '#fff',
              fontSize: 22
            }
          },
          axisTick: {
            show: false,
          },
        },
        {
          name: "",
          position: 'left',
          nameTextStyle: {
            color: "#fff",
            // fontSize: 24,
            padding: [0, 0, 0, 0]
          },
          // minInterval: 1,
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: '#327490',
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'black',
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
              // fontSize: 22
            }
          },
          axisTick: {
            show: false,
          },
        },
      ],
      series: [
        {
          name: '总数',
          type: 'line',
          symbol: 'none', // 默认是空心圆（中间是白色的），改成实心圆
          smooth: true,
          yAxisIndex: 1,
          lineStyle: {
            normal: {
              width: 3,
              color: '#3087fe', // 线条颜色
            },
          },
          areaStyle: {
            normal: {
              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: this.$echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: '#3087fe30',
                  },
                  {
                    offset: 0.6,
                    color: '#3087fe20',
                  },
                  {
                    offset: 1,
                    color: '#3087fe10',
                  },
                ],
                false
              ),
            },
          },
          data: yAxisData1,
        },
        {
          name: '男',
          type: 'line',
          symbol: 'none', // 默认是空心圆（中间是白色的），改成实心圆
          smooth: true,
          lineStyle: {
            normal: {
              width: 3,
              color: '#05fef5', // 线条颜色
            },
          },
          yAxisIndex: 1,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(47, 145, 255, 0.3)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(47,145,255,0)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            },
          },
          data: yAxisData2,
        },
        {
          name: '女',
          type: 'line',
          symbol: 'none', // 默认是空心圆（中间是白色的），改成实心圆
          smooth: true,
          lineStyle: {
            normal: {
              width: 3,
              color: '#f64d6b', // 线条颜色
            },
          },
          yAxisIndex: 1,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: 'rgba(47, 145, 255, 0.3)' // 0% 处的颜色
              }, {
                offset: 1, color: 'rgba(47,145,255,0)' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            },
          },
          data: yAxisData3,
        }
      ]
    }
    chart04.setOption(option, true)
  }
}
</script>

<style>
.echart04 {
    font-size: 10px;
    font-weight: 700;
    width: 100%;
}
</style>
